import React, { FC, memo } from 'react'

import { IUniversityInfoProps } from '../types'

import { Item } from '../components/Item'

const SchoolInfo: FC<IUniversityInfoProps> = ({ data, tags }) => {
  const { priceFrom, priceTo, abroadTypes, admissionConditions, learningConditions } =
    data || {}

  return (
    <>
      {priceFrom && priceTo && (
        <Item title='Стоимость обучения' description={`От ${priceFrom} до ${priceTo}`} />
      )}

      {abroadTypes && (
        <Item
          title='Типы программ'
          description={abroadTypes.map(({ name }) => name).join(', ')}
        />
      )}

      {tags && (
        <Item
          title='Популярные специальности'
          description={tags.map(({ name }) => name).join(', ')}
        />
      )}

      {admissionConditions && (
        <Item title='Условия поступления' description={admissionConditions} />
      )}

      {learningConditions && (
        <Item title='Условия обучения' description={learningConditions} />
      )}
    </>
  )
}

export default memo(SchoolInfo)
